module.exports = __webpack_public_path__ + "media/images/icons/black_dollar-838bdeee9eade67560cc6af879493561.svg";